import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';

export default extend(dialog, {
	namespaced: true,
	state: {
		form: {},
	},
	actions: {
		async afterOpenDialog({ dispatch, commit }, payload) {
			commit('save', {
				form: {}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/cs/consumer/create.js